<template>
  <div class="home">
    <MessageMain/>
  </div>
</template>

<script>
import MessageMain from '@/components/MessageMain'

export default {
  components: {
    MessageMain
  }
}
</script>
